import { useAutoTranslate } from '../../utils/autoTranslate';

/**
 * Renders one piece of stored free text, machine-translated into the active language.
 *
 * Use it for user-typed prose — notes, reasons, addresses, descriptions. Do NOT use it for names,
 * account codes, CNIC numbers, amounts or dates: translating an identifier corrupts it, and figures
 * must match the receipts and the database exactly.
 *
 * Falls back to the original text while loading, in English, or if translation is unavailable, so a
 * record is never blank.
 */
export default function AutoText({ value, fallback = '—' }: { value: string | null | undefined; fallback?: string }) {
  const translated = useAutoTranslate(value);
  return <>{value?.trim() ? translated : fallback}</>;
}
